import { useNavigate } from "react-router-dom";
import { AppBarComponent } from "../Components/AppBar";
import { config } from "../Components/config";
import { Alert, Container } from "@mui/material";

function ErrorUnathorized() {
  const navigate = useNavigate();
  console.log("UnathorizedError");
//   setTimeout(() => {
//     navigate("/Homepage");
//   }, 5000);
  return (
    <Container sx={{marginTop:2}}>
      <Alert variant="outlined" severity="warning">
        <b>Alerta</b>
        <br />
        Haz intentado ingresar a una ruta no autorizada.
      </Alert>
    </Container>
  );
}

export { ErrorUnathorized };
